module.exports = __webpack_public_path__ + "static/media/american-express.6e592c4a.png";